import React, { useState } from "react";
import closeIcon from "../../Assets/Icons/close.png";
import Loader from "../Loader"; // Optional if you want a loading indicator during submit
import Input from "../Input";
import MobileInput from "../MobileInput";
import { validateEmail } from "../../Utils/Validation";
import { ORG_SHARE_DOC_LINK } from "../../ApiServices/BaseURL";
import { postData } from "../../ApiServices/ApiService";
import { logFrontendException } from "../../Utils/Exception";
import { useTheme } from "../../GlobalContext/GlobalContext";

const ShareDocumentLinkModal = ({
    isOpen,
    onClose,
    defaultEmail,
    defaultMobileCode,
    defaultMobile,
    taskId,
    clientId,
}) => {
    const [email, setEmail] = useState(defaultEmail || "");
    const [emailError, setEmailError] = useState("");
    const [mobile, setMobile] = useState(defaultMobile || "");
    const [countryCode, setCountryCode] = useState(defaultMobileCode || "");
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [documentNames, setDocumentNames] = useState([{ name: "" }]); // State to store document names
    const pageName = "ShareDocumentLinkModal";
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    const { setIsLoginPopup } = useTheme();
    
    const resetForm = () => {
        setEmail(defaultEmail || "");
        setMobile(defaultMobile || "");
        setCountryCode(defaultMobileCode || "")
        setErrorMessage("");
        setSuccessMessage('');
        setEmailError('');
        setDocumentNames([{ name: "" }]); // Reset document names
    };

    const handleAddDocumentField = () => {
        setDocumentNames([...documentNames, { name: "" }]); // Add new input field
    };

    const handleDocumentNameChange = (index, value) => {
        const updatedDocumentNames = [...documentNames];
        updatedDocumentNames[index].name = value;
        setDocumentNames(updatedDocumentNames);
    };

    const handleSubmit = async () => {
        try {
            setEmailError('');
            setErrorMessage('');
            if (!email && !mobile) {
                setErrorMessage("At least one of Email or Mobile is required.");
                return;
            }
            if (email) {
                if (!validateEmail(email)) {
                    setEmailError("Enter valid email id.");
                }
            }
            const filteredData = documentNames.filter(item => item?.name?.trim() !== "");

            // Check if at least one document name is provided
            if (filteredData.length < 1) {
                console.log('documentNames:-',documentNames)
                setErrorMessage("At least one document name is required.");
                return;
            }

            setLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload = {
                "emp_id_auth": storedUserInfo?.emp_id,
                "task_id": taskId || 0,
                "client_id": clientId || 0,
                "contact_email": email || '',
                "contact_phone_no": mobile || '',
                "contact_phone_code": countryCode || '',
                "documents": filteredData // Send document names in the payload
            }
            const response = await postData(ORG_SHARE_DOC_LINK, payload);
            const responseData = await response.json();

            if (response.status === 200 && responseData.status_code === 200) {
                if (responseData.message.toLowerCase() === "success") {
                    setSuccessMessage(responseData?.info || '');
                    setTimeout(() => {
                        setSuccessMessage('');
                        resetForm();
                        onClose();
                    }, 3000);
                } else {
                    setErrorMessage(responseData?.info || "Failed to send link.");
                    logFrontendException(storedUserId, pageName, "handleSubmit", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setErrorMessage('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true);
                logFrontendException(storedUserId, pageName, "handleSubmit", responseData || response || '');
            } else {
                setErrorMessage(responseData?.info || "Failed to send link.");
                logFrontendException(storedUserId, pageName, "handleSubmit", responseData || response || '');
            }
        } catch (err) {
            console.log('error', err);
            setErrorMessage("Network error. Please try again.");
            logFrontendException(storedUserId, pageName, "handleSubmit-catch", err || 'Network error. Please try again.');

        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="close-button" onClick={() => { resetForm(); onClose(); }}>
                    <img src={closeIcon} alt="Close" style={{ width: 16, height: 16 }} />
                </button>
                <h2 className="modal-title">Share Upload Link</h2>
                <hr className="title-divider" />

                <div style={{ paddingTop: 10, paddingBottom: 20, fontSize: '14px', fontFamily: 'Nunito Sans' }}>Verify Client information below to share document share link with client.</div>

                <div className="form-grid">
                    <Input
                        label="Email"
                        type="text"
                        placeholder="Enter email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        errorMessage={emailError || ''}
                    />

                    <MobileInput
                        label="Mobile Number"
                        countryCode={countryCode || ""}
                        mobileNumber={mobile || ""}
                        onCountryChange={(value) => setCountryCode(value)}
                        onMobileChange={(value) => setMobile(value)}
                        placeholder={`Enter mobile number`}
                        countries={[
                            { code: "IN", dialCode: "+91" },
                            { code: "US", dialCode: "+1" },
                            { code: "UK", dialCode: "+44" },
                        ]}
                    // errorMessage={!email && !mobile && errorMessage ? errorMessage : ""}
                    />
                    
                    {/* Render dynamic document input fields */}
                    {documentNames.map((doc, index) => (
                        <div key={index} style={{ marginBottom: '10px' }}>
                            <Input
                                label={`Document Name ${index + 1}`}
                                type="text"
                                placeholder="Enter document name"
                                value={doc.name}
                                onChange={(e) => handleDocumentNameChange(index, e.target.value)}
                            />
                        </div>
                    ))}
                </div>

                <button 
                    className="add-client-button" 
                    onClick={handleAddDocumentField} 
                    style={{ marginBottom: "10px" }}
                >
                    Add Document
                </button>

                <hr className="title-divider" />
                <div style={{ display: "flex", alignItems: 'center' }}>
                    <button className="add-client-button" onClick={handleSubmit} disabled={loading || successMessage}>
                        {loading && <span style={{paddingRight:10}}> <Loader loading={true} size="small" color="white" /> </span>} Share Link
                    </button>
                    <button className="cancel-button" onClick={() => { resetForm(); onClose(); }}>Cancel</button>
                    {errorMessage && <div className="list-error-msg">{errorMessage}</div>}
                    {successMessage && <div className="list-success-msg"> {successMessage} </div>}
                </div>
            </div>
        </div>
    );
};

export default ShareDocumentLinkModal;
